module.exports = __webpack_public_path__ + "img/Fahrrad.3e93d588.svg";